import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Clock, Calendar, Globe } from "lucide-react";
import CTAButton from "../CTAButton";

const EventDetailsTimerSection: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      // Set target date: October 30th, 2025 at 1:00 PM IST
      const targetDate = new Date('2025-10-30T13:00:00+05:30'); // IST timezone
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference > 0) {
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        return { hours, minutes };
      } else {
        // Event has passed, show 0
        return { hours: 0, minutes: 0 };
      }
    };

    // Set initial time
    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center"
        >
          {/* Left Section - Event Details */}
          <div className="text-center lg:text-left">
            <div className="space-y-6">
              {/* Event Date & Time */}
              <div>
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-black mb-2">
                  STARTS ON 30th October 2025
                </h2>
                <p className="text-lg sm:text-xl text-gray-600 mb-4">
                  (1:00 PM IST)
                </p>
                <p className="text-lg sm:text-xl text-gray-600">
                  Language - Basic English
                </p>
              </div>

              {/* Registration Button */}
              <div className="pt-4">
                <CTAButton
                  text="REGISTER NOW AT ₹299/- ONLY"
                  calendlyUrl="https://calendly.com/your-calendly-link"
                  className="bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-8 rounded-lg text-lg md:text-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                  icon={false}
                  isWebinarRegistration={true}
                />
              </div>
            </div>
          </div>

          {/* Right Section - Timer */}
          <div className="text-center">
            <div className="space-y-6">
              {/* Call to Action */}
              <h3 className="text-xl sm:text-2xl text-black font-semibold">
                Register in next
              </h3>

              {/* Timer Display */}
              <div className="flex justify-center items-center space-x-4">
                <div className="bg-gray-100 border-2 border-gray-300 rounded-lg px-6 py-4 md:px-8 md:py-6">
                  <div className="text-4xl md:text-5xl font-bold text-black mb-2">
                    {timeLeft.hours.toString().padStart(2, "0")}
                  </div>
                  <div className="text-sm md:text-base text-black text-center">Hours</div>
                </div>
                
                <div className="bg-gray-100 border-2 border-gray-300 rounded-lg px-6 py-4 md:px-8 md:py-6">
                  <div className="text-4xl md:text-5xl font-bold text-black mb-2">
                    {timeLeft.minutes.toString().padStart(2, "0")}
                  </div>
                  <div className="text-sm md:text-base text-black text-center">Minutes</div>
                </div>
              </div>

              {/* Bonus Value */}
              <div className="text-center">
                <p className="text-lg sm:text-xl text-black font-semibold">
                  To Unlock Bonuses Worth ₹21,246 
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EventDetailsTimerSection;
